/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
import axiosRetry from 'axios-retry';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const axiosWithRetry = axios.create({
	timeout: 5000,
});

axiosRetry(axiosWithRetry, {
	retries: 2,
	retryDelay: axiosRetry.exponentialDelay,
});

window.axiosWithRetry = axiosWithRetry;

// Moved the Echo import under Layout.jsx for now. It should only be used on Connect.
//import './echo';
